import CONSTANTS from 'src/utils/constants';

export interface MECState {
    selectedTab: string
}

export const initialState: MECState = {
    selectedTab: CONSTANTS.MEC_TABS.PREVALIDATION
}